export default __webpack_public_path__ + "static/media/banh-tom.45579e43.jpg";